export const toastStyle = {
	position: 'top-center',
	closeDuration: 1000
}
